<template>
  <div v-if="shops.length" class="container">
    <BaseTitle v-if="title" :tag="tag">{{ title }}</BaseTitle>
    <div class="shops-grid">
      <ShopItem
        v-for="shop in shops"
        :key="shop.id"
        :shop="shop"
        class="shop-item"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  useSimilarShopsForShopQuery,
  type SimilarShopsForShopInput,
  type PaginationInput,
} from "~~/graphql/generated";

const props = defineProps<{
  title?: string;
  input: SimilarShopsForShopInput;
  pagination: PaginationInput;
  showLoadMore?: boolean;
  tag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}>();

const { data } = await useSimilarShopsForShopQuery({
  variables: {
    shopInput: props.input,
    pagination: props.pagination,
  },
});

const shops = computed(() => data.value?.similarShopsForShop ?? []);
</script>

<style lang="scss" scoped>
.shops-grid {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));
  @include for-extra-small-screen {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
